import { RenterDto } from '@tallo/renter';

import { ShowingRequestStatus } from '../interfaces/showing-request-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';

export function getCanceledRenters(showing: ShowingDto): RenterDto[] {
  return showing.showingRequests
    .filter(({ status }) => {
      return [ShowingRequestStatus.CANCELED_BY_RENTER, ShowingRequestStatus.CANCELED_BY_INVESTOR].includes(status);
    })
    .map(({ renter }) => renter);
}
